import _ from 'underscore';

import { WebClientListWithTokenResourceFetcher } from '~src/commonInfra/utils/resourceFetchers/WebClientListWithTokenResourceFetcher';
import { SiteAuthenticationSettingsService } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { IListWithTokenFetcher } from '~src/ts/fetchers/IListWithTokenFetcher';
import { ListResultWithToken } from '~src/ts/fetchers/ListResultWithToken';
import { ServerApiMapper } from '~src/ts/helpers/ServerModelHelper';
import { ResourceQueryWithPagingToken } from '~src/ts/resources/ResourceQueryWithPagingToken';
import { GetSiteUsersWithTokenRequest } from '~src/ts/ServerApi/requests/GetSiteUsersWithTokenRequest';
import { IPagedItemsWithTokenParams } from '~src/ts/ServerApi/types/IPageWithToken';
import { ISiteUserInfo } from '~src/userManagement/users/models/ISiteUserInfo';


function fetchList(params: IPagedItemsWithTokenParams): Promise<ListResultWithToken<ISiteUserInfo>> {
  let listFetcher: IListWithTokenFetcher<ISiteUserInfo> = new WebClientListWithTokenResourceFetcher(GetSiteUsersWithTokenRequest, ServerApiMapper.siteUsersWithToken);

  if (!SiteAuthenticationSettingsService.isEnabled()) {
    return listFetcher.fetchList(params);
  }
  return Promise.all([
    listFetcher.fetchList(params),
    SiteAuthenticationSettingsService.getAuthSettingToProviderIdMap()])
  .then((results: any[]) => {
    const userList: ListResultWithToken<ISiteUserInfo> = results[0];
    const map: _.Dictionary<string> = results[1];

    _.each(userList.items, (siteUser: ISiteUserInfo) => {
      siteUser.authenticationProviderId = map[siteUser.authSetting];
    });
    return userList;
  });
}

export const AuthenticationProviderIdFetcherForGetSiteUsersToken = {fetchList};

export class SiteUsersWithToken extends ResourceQueryWithPagingToken<ISiteUserInfo> {
  public static readonly instance = new SiteUsersWithToken(AuthenticationProviderIdFetcherForGetSiteUsersToken);
}

export const SiteUsersWithTokenResource = SiteUsersWithToken.instance;
